<template>
  <v-app v-if="fluidPage">
    <v-navigation-drawer v-model="drawer" app color="#263238">
      <div id="header-nav" :style="'--p-primary_color: ' + primary_color">
        <img
          :src="logo"
          alt="logo"
          height="48"
        />
      </div>
      <ul class="list-style-none pa-0">
        <li
          class="li-item-nav py-2"
          @click="
            active.dashboard = !active.dashboard;
            active.settings = false;
          "
        >
          <div class="pa-2 d-flex align-center justify-space-between fluid">
            <div class="d-flex align-center">
              <img src="./assets/icons/menu/dashboard.svg" alt="" />
              <span class="ml-4 body-2 white--text">Dashboard</span>
            </div>
            <v-icon v-bind:class="{'rotate': active.dashboard}" color="white">
                mdi-menu-right
              </v-icon>
          </div>
        </li>
        <div v-if="active.dashboard">
          <router-link
            v-if="permissions.indexOf('view_global_dashboard') != -1"
            to="dashboard"
            v-slot="{ isActive, navigate }"
          >
            <li
              class="li-item-nav py-2 darken-2 item-sub"
              @click="navigate"
              v-on:click="navItem = false"
            >
              <div :class="[isActive && 'li-item-active']" :style="'--p-secondary_color: ' + secondary_color" class="pa-2">
                <span class="ml-4 body-2 white--text">Dashboard Geral</span>
              </div>
            </li>
          </router-link>
          <router-link to="dashboard-canal" v-slot="{ isActive, navigate }">
            <li
              class="li-item-nav blue-grey darken-2 py-2"
              @click="navigate"
              v-on:click="navItem = false"
            >
              <div :class="[isActive && 'li-item-active']" :style="'--p-secondary_color: ' + secondary_color" class="pa-2">
                <span class="ml-4 body-2 white--text">Dashboard Canal</span>
              </div>
            </li>
          </router-link>
        </div>
        <router-link
          v-if="permissions.indexOf('manage_users') != -1"
          to="usuarios"
          v-slot="{ isActive, navigate }"
        >
          <li
            class="li-item-nav py-2"
            @click="navigate"
            v-on:click="navItem = false"
          >
            <div :class="[isActive && 'li-item-active']" :style="'--p-secondary_color: ' + secondary_color" class="pa-2 d-flex align-center">
              <img src="./assets/icons/menu/users.svg" alt="" />
              <span class="ml-4 body-2 white--text">Usuários</span>
            </div>
          </li>
        </router-link>
        <router-link
          v-if="permissions.indexOf('manage_channels') != -1"
          to="canais"
          v-slot="{ isActive, navigate }"
        >
          <li
            class="li-item-nav py-2"
            @click="navigate"
            v-on:click="navItem = false"
          >
            <div :class="[isActive && 'li-item-active']" :style="'--p-secondary_color: ' + secondary_color" class="pa-2 d-flex align-center">
              <img src="./assets/icons/menu/youtube.svg" alt="" />
              <span class="ml-4 body-2 white--text">Canais</span>
            </div>
          </li>
        </router-link>
        <router-link
          v-if="permissions.indexOf('authorize_channels') != -1"
          to="autorizacao-canais"
          v-slot="{ isActive, navigate }"
        >
          <li
            class="li-item-nav py-2"
            @click="navigate"
            v-on:click="navItem = false"
          >
            <div :class="[isActive && 'li-item-active']" :style="'--p-secondary_color: ' + secondary_color" class="pa-2 d-flex align-center">
              <img src="./assets/icons/menu/compare.svg" alt="" />
              <span class="ml-4 body-2 white--text">Autorização de canais</span>
            </div>
          </li>
        </router-link>
        <router-link
          v-if="permissions.indexOf('manage_channels') != -1"
          to="cms"
          v-slot="{ isActive, navigate }"
        >
          <li
            class="li-item-nav py-2"
            @click="navigate"
            v-on:click="navItem = false"
          >
            <div :class="[isActive && 'li-item-active']" :style="'--p-secondary_color: ' + secondary_color" class="pa-2 d-flex align-center">
              <img src="./assets/icons/menu/cms.svg" alt="" />
              <span class="ml-4 body-2 white--text">CMS</span>
            </div>
          </li>
        </router-link>
        <router-link 
          v-if="permissions.indexOf('manage_reports') != -1"
          to="report" 
          v-slot="{ isActive, navigate }"
        >
          <li
            class="li-item-nav py-2"
            @click="navigate"
            v-on:click="navItem = false"
          >
            <div :class="[isActive && 'li-item-active']" :style="'--p-secondary_color: ' + secondary_color" class="pa-2 d-flex align-center">
              <img src="./assets/icons/menu/report.svg" alt="" />
              <span class="ml-4 body-2 white--text">Relatórios</span>
            </div>
          </li>
        </router-link>
        <li
          class="li-item-nav py-2"
          @click="logout()"
        >
          <div class="pa-2 d-flex align-center">
            <div class="d-flex align-center">
              <img src="./assets/icons/menu/exit.svg" alt="" />
              <span class="ml-4 body-2 white--text">Sair</span>
            </div>
          </div>
        </li>
      </ul>
    </v-navigation-drawer>

    <v-app-bar app :color="primary_color">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <div class="px-6 border-nav-item" :style="'--p-tertiary_color: ' + tertiary_color">
        <span class="subtitle-2">{{ profile_name }}</span>
        <v-menu left bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-list class="px-4">
            <v-list-item @click="logout()">
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <v-main>
      <v-container>
        <router-view />
      </v-container>
    </v-main>
  </v-app>

  <v-app v-else>
    <v-main class="blue-grey darken-4 d-flex align-center">
      <v-container class="d-flex align-center justify-center">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getClientColorByKey } from './utils/clientColor.js'

export default {
  name: "App",
  created() {
    this.logo = localStorage.logo_plataform;

    if (this.logo == null || this.logo == undefined) {
      /* Set 1BM default logo */
      this.logo = "https://s3.us-east-1.amazonaws.com/storage.v1.dev.andromeda.nscreen.com.br/client_logo/1/black.png";
    }

    this.onPageChange();
    this.loadData();
  },
  updated() {
    this.onPageChange();
  },
  data: () => ({
    active: {
      settings: false,
      dashboard: false,
    },
    fluidPage: false,
    drawer: null,
    permissions: "",
    profile_name: "",
    logo: "",
    primary_color: getClientColorByKey("primary_color"),
    secondary_color: getClientColorByKey("secondary_color"),
    tertiary_color: getClientColorByKey("tertiary_color"),
  }),
  methods: {
    onPageChange() {
      let fluidPage = true;
      if (
        this.$route.path.indexOf("/login") > -1 ||
        this.$route.path.indexOf("/redefinir-senha") > -1 ||
        this.$route.path.indexOf("/esqueci-minha-senha") > -1 ||
        this.$route.path.indexOf("/erro/") > -1
      ) {
        fluidPage = false;
      }

      if (this.fluidPage !== fluidPage) {
        this.fluidPage = fluidPage;
      }
    },
    loadData() {
      const token = this.$jwt.decode();

      if (token) {
        this.permissions = token.data.permissions;
        this.getUser();
      }
    },
    logout() {
      localStorage.removeItem("session");
      window.location.href = "/login";
    },
    getUser() {
      this.$http.get("/user-profile").then((res) => {
        this.profile_name = res.data.name;
      });
    },
  },
  watch: {
    '$route':{
        handler: (to) => {
          document.title = to.meta.title || 'Dashboard - 1BMG'
        },
         immediate: true
      }
  }
};
</script>

<style>
.fluid {
  width: 100%;
}
.table-min-height {
  min-height: 60vh;
}
.height-fluid {
  height: 100%;
}
.button-primary {
  max-width: 184px;
  width: 100%;
}
.decoration-none {
  text-decoration: none;
}
.underline {
  text-decoration: underline;
}
.list-style-none {
  list-style: none;
}
.pointer {
  cursor: pointer !important;
}
.initial-card {
  border-top: 8px solid #fdd835;
  border-bottom: 8px solid #fdd835;
  background-color: white;
  max-width: 616px;
  width: 100%;
  max-height: 100%;
  border-radius: 4px;
  padding-bottom: 56px;
}
.error-card {
  max-width: 504px;
  width: 100%;
  max-height: 100%;
  border-radius: 4px;
}
.error-header {
  position: relative;
  height: 100px;
  border-top: 8px solid #ff5252;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-radius: 4px;
}
.error-border-bottom {
  height: 8px;
  width: 100%;
  background: #ff5252;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.error-image {
  position: absolute;
  top: -145px;
  left: 32%;
}
.border-nav-item {
  color: var(--p-tertiary_color);
  border-left: 2px solid #ffffff14;
  height: 100%;
  align-items: center;
  display: flex;
}
#header-nav {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--p-primary_color);
}
.item-sub {
  background-color: #455a64 !important;
  border-bottom: 1px solid #252a2c !important;
}
.li-item-nav {
  display: flex;
  align-items: center;
  background-color: #263238;
  border-bottom: 1px solid #455a64;
  cursor: pointer;
  animation: show 0.2s ease-out;
}
.li-item-nav-sub {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #455a64;
  border-left: 4px solid #f5f5f5;
  cursor: pointer;
  animation: show 0.2s ease-out;
}
.li-item-nav:hover {
  background: #33424b;
}
.li-item-active {
  border-left: 2px solid var(--p-secondary_color);
}
.li-item-nav-sub:hover {
  background: #ebebeb;
}
.border-b {
  border-bottom: 1px solid #f3f3f3 !important;
}
.rotate {
  transform: rotate(90deg);
}
.rotate {
  transform: rotate(90deg);
}

@keyframes show {
  from {opacity: 0;}
  to {opacity: 1}
}
</style>

